const explore = [
  { label: "现场直击", anchor: "scene" },
  { label: "塌房档案", anchor: "archive" },
  { label: "崩塌全记录", anchor: "timeline" },
  { label: "口碑预警", anchor: "reputation" },
];

const topics = ["塌房现场", "人设崩塌", "脱粉瞬间", "口碑崩盘", "实锤档案", "辟谣速报"];

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-200/50">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-12">
        <div className="grid gap-8 md:grid-cols-12">
          {/* 品牌 */}
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 font-display text-lg font-black text-background-50">
                呱
              </span>
              <span className="font-display text-xl font-black text-foreground-950">呱呱黑料</span>
            </a>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-foreground-600">
              呱呱黑料塌房现场直击，记录人设崩塌的全过程。聚焦脱粉瞬间与口碑崩盘，把滤镜破碎背后的真相，按证据与时间线完整摆给你。
            </p>
            <div className="mt-4 flex items-center gap-3">
              {["ri-weibo-fill", "ri-twitter-x-line", "ri-youtube-fill"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="社交账号"
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-colors hover:bg-foreground-950 hover:text-background-50"
                >
                  <i className={`${ic} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* 栏目 */}
          <div className="md:col-span-3">
            <h4 className="mb-3 text-sm font-bold text-foreground-950">栏目直达</h4>
            <ul className="space-y-2.5">
              {explore.map((e) => (
                <li key={e.anchor}>
                  <a
                    href={`#${e.anchor}`}
                    className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {e.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 主题标签 */}
          <div className="md:col-span-4">
            <h4 className="mb-3 text-sm font-bold text-foreground-950">正在围观</h4>
            <div className="flex flex-wrap gap-2">
              {topics.map((t) => (
                <a
                  key={t}
                  href="#feed"
                  className="cursor-pointer whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-600 ring-1 ring-background-200 transition-colors hover:bg-accent-500 hover:text-foreground-950"
                >
                  # {t}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* 底部说明条 */}
        <div className="mt-9 flex flex-col gap-2 border-t border-background-300/70 pt-5 text-[12px] text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>
            呱呱黑料 · 塌房现场与人设崩塌观察站。本站为娱乐信息整理类演示页面，内容不构成对任何真实人物与事件的定性。
          </p>
          <p className="flex items-center gap-3">
            <span>© {new Date().getFullYear()} 呱呱黑料</span>
            <a href="#top" className="inline-flex items-center gap-1 cursor-pointer hover:text-foreground-900">
              回顶部 <i className="ri-arrow-up-line"></i>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}